import { debounce } from 'lodash';
import { useEffect, useState } from 'react';

import { BREAKPOINTS, DEBOUNCE_WINDOW_RESIZE } from '@/common/constants';

const useBreakpoints = (
  resize = true,
  debouncedResizeDelay = DEBOUNCE_WINDOW_RESIZE,
) => {
  const { offsetWidth } = document.body;

  const [isMinPhone, setIsMinPhone] = useState(
    offsetWidth >= BREAKPOINTS.phone,
  );
  const [isMinTablet, setIsMinTablet] = useState(
    offsetWidth >= BREAKPOINTS.tablet,
  );
  const [isMinDesktop, setIsMinDesktop] = useState(
    offsetWidth >= BREAKPOINTS.desktop,
  );
  const [isMinFull, setIsMinFull] = useState(offsetWidth >= BREAKPOINTS.full);
  const [isMaxPhone, setIsMaxPhone] = useState(offsetWidth < BREAKPOINTS.phone);
  const [isMaxTablet, setIsMaxTablet] = useState(
    offsetWidth < BREAKPOINTS.tablet,
  );
  const [isMaxDesktop, setIsMaxDesktop] = useState(
    offsetWidth < BREAKPOINTS.desktop,
  );
  const [isMaxFull, setIsMaxFull] = useState(offsetWidth < BREAKPOINTS.full);

  useEffect(() => {
    const handleResize = () => {
      const newOffsetWidth = document.body.offsetWidth;
      setIsMinPhone(newOffsetWidth >= BREAKPOINTS.phone);
      setIsMinTablet(newOffsetWidth >= BREAKPOINTS.tablet);
      setIsMinDesktop(newOffsetWidth >= BREAKPOINTS.desktop);
      setIsMinFull(newOffsetWidth >= BREAKPOINTS.full);
      setIsMaxPhone(newOffsetWidth < BREAKPOINTS.phone);
      setIsMaxTablet(newOffsetWidth < BREAKPOINTS.tablet);
      setIsMaxDesktop(newOffsetWidth < BREAKPOINTS.desktop);
      setIsMaxFull(newOffsetWidth < BREAKPOINTS.full);
    };
    if (resize) {
      const listener =
        debouncedResizeDelay > 0
          ? debounce(handleResize, debouncedResizeDelay)
          : handleResize;
      window.addEventListener('resize', listener);

      return () => {
        window.removeEventListener('resize', listener);
      };
    }

    return () => null;
  }, [debouncedResizeDelay, resize]);

  return {
    isMinPhone,
    isMinTablet,
    isMinDesktop,
    isMinFull,
    isMaxPhone,
    isMaxTablet,
    isMaxDesktop,
    isMaxFull,
  };
};

export default useBreakpoints;
